import { FormizoSchema } from "Components/LabIZO/Formizo/FormizoSchema.interface";

export const TimeoutSetting: FormizoSchema[] = [
  {
    header: "Time setting(mins)",
  },
  {
    label: "1st time out (mins):",
    name: "SettingDoc.TimeSetting.1st",
    variant: "outlined",
    format: "number",
  },
  {
    label: "2nd time out (mins):",
    name: "SettingDoc.TimeSetting.2nd",
    variant: "outlined",
    format: "number",
  },
  {
    header: "Question",
  },
  {
    label: "TC:",
    name: "SettingDoc.Question.TC",
    variant: "outlined",
    format: "textarea",
  },
  {
    label: "SC",
    name: "SettingDoc.Question.SC",
    variant: "outlined",
    format: "textarea",
  },
  {
    label: "EN",
    name: "SettingDoc.Question.EN",
    variant: "outlined",
    format: "textarea",
  },
  {
    header: 'Reply for clicking "yes" to continue',
  },
  {
    label: "TC",
    name: "SettingDoc.Continue.TC",
    variant: "outlined",
    format: "textarea",
  },
  {
    label: "SC",
    name: "SettingDoc.Continue.SC",
    variant: "outlined",
    format: "textarea",
  },
  {
    label: "EN",
    name: "SettingDoc.Continue.EN",
    variant: "outlined",
    format: "textarea",
  },
];
